// @flow

import React, { useState, useRef } from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "@components";
import { SchemaForm } from "@components";
import { uiSchema } from "./uiSchema";
import { isBefore } from "date-fns";

type Props = {
  onDismissHandler: Function,
  onSubmit: Function,
  schema: Object | null,
  uiSchema: Object | null,
  ...PropsFromLocalize,
};

type State = $Exact<{
  isEnabled: boolean | null,
}>;

export function EmailDomainAddModal(props: Props) {
  const formRef = useRef(null);
  const [formData, setFormData] = useState({});

  function submitForm() {
    formRef.current.submit();
  }

  function handleSubmit(formData: Object) {
    props.onSubmit(formData);
  }

  function handleChange(formData: Object) {
    if (isBefore(formData.activeTo, new Date())) {
      formData.isEnabled = false;
    }

    setFormData(formData);
  }

  return (
    <Modal className="modal-small">
      <ModalHeader toggle={props.onDismissHandler} className="d-flex justify-content-between">
        {props.t("ADD_EMAIL_DOMAIN")}
      </ModalHeader>
      <ModalBody>
        <SchemaForm
          ref={formRef}
          schema={props.schema}
          formData={formData}
          onChange={handleChange}
          onSubmit={handleSubmit}
          uiSchema={uiSchema(props.t)}
          externalSubmit
        />
      </ModalBody>
      <ModalFooter className="d-flex justify-content-end">
        <Button color="secondary" onClick={props.onDismissHandler}>
          {props.t("CANCEL")}
        </Button>
        <Button materialIcon="add_box" onClick={submitForm}>
          {props.t("ADD")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default localize()(EmailDomainAddModal);
